
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AffiliateInviteLog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AffiliateInviteLog"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"App"},"directives":[]}]}}]}}],"loc":{"start":0,"end":337}};
    doc.loc.source = {"body":"# Fragment in graphql file\n# https://github.com/Akryum/vue-summit-app/blob/master/app/src/graphql/QuestionAdd.gql\n#import '@/plugins/graphql/fragments/app.gql'\n#import '@/plugins/graphql/fragments/user.gql'\n\nfragment AffiliateInviteLog on AffiliateInviteLog {\n  uuid\n  email\n  createdAt\n  user {\n    ...User\n  }\n  app {\n    ...App\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/plugins/graphql/fragments/app.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/plugins/graphql/fragments/user.gql').definitions));


      module.exports = doc;
    
